<template>
	<select2>
		<option v-for="data in datos" :value="data">
			{{data}}
		</option>
	</select2>
</template>
<script>
	export default {
		data(){
			return {
				datos: [
					'Tipo',
					'Llamada',
					'Visita',
					'Correo',
					'WhatsApp',
					'Seguimiento a Cliente',
					'Soporte Interno',
				],
			}
		},

		mounted(){
			var vm = this
            
			$(this.$el)
			.val(this.value)
            .on('change', function () {
           		vm.$emit('input', this.value)
            });
		},

		watch: {
            value: function (value) {
            	$(this.$el).val(value).trigger('change');
            },
        }
	}
</script>